module.exports = __webpack_public_path__ + "static/img/inventario_plataforma.96191e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inventario_plataforma.png
// module id = 95
// module chunks = 0